module.exports = __webpack_public_path__ + "img/2-1.043846f7.png";